import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getFilters } from '../../webcommon/header/filterheader/selectors';
import FilterHeader from '../../webcommon/header/filterheader/FilterHeader';
import Grid from '../../webcommon/grid/Grid';
import GridHeader from '../../common/gridheader/GridHeader';
import styles from './fileAvailability.module.scss';
import * as actions from './actions';
import * as selectors from './selectors';
import * as fileAvailabilityApi from '../../api/fileAvailabilityApi';
import { SOURCE_DISPLAY, SOURCES } from './constants';

const FileAvailability = ({
    columns, rows, loading, isSupport, lastUpdated, runDate, dispatch
}) => {
    useEffect(() => {
        dispatch(actions.fileAvailabilityConnected());
    }, [dispatch]);

    const handleRefresh = useCallback(() => {
        dispatch(actions.refreshFileAvailability());
    }, [dispatch]);

    const availableCount = rows.filter(r => r.status === 'Available').length;

    return (
        <div className={ styles.fileAvailability }>
            <div className={ styles.filterHeaderWrapper }>
                <FilterHeader
                    fixed
                    title="SIMM File Availability"
                    id="FileAvailability"
                />
            </div>
            <div className={ styles.gridHeaderContainer }>
                <GridHeader
                    title="SIMM Files Available"
                    lastUpdated={ lastUpdated }
                    refreshControlsActive
                    refreshData={ handleRefresh }
                >
                    { isSupport && <div className={ styles.headerSeparator }>&nbsp;</div> }
                    { isSupport && (
                        <button
                            type="button"
                            className={ styles.headerDownloadBtn }
                            disabled={ availableCount === 0 }
                            onClick={ () => fileAvailabilityApi.downloadAllFilesZip(runDate) }
                        >
                            { `Download All (${availableCount})` }
                        </button>
                    ) }
                </GridHeader>
            </div>
            <div className={ styles.sourcesWrapper }>
                { loading && <div className={ styles.loading }>Loading&hellip;</div> }
                { !loading && SOURCES.map(source => {
                    const sourceRows = rows.filter(r => r.sourceFolder && r.sourceFolder.toLowerCase() === source);
                    const availableInSource = sourceRows.filter(r => r.status === 'Available').length;
                    return (
                        <div key={ source } className={ styles.sourceSection }>
                            <div className={ styles.sourceHeader }>
                                <span className={ styles.sourceTitle }>{ SOURCE_DISPLAY[source] }</span>
                                { isSupport && (
                                    <button
                                        type="button"
                                        className={ styles.downloadBtn }
                                        disabled={ availableInSource === 0 }
                                        onClick={ () => fileAvailabilityApi.downloadSourceZip(source, runDate) }
                                    >
                                        { `Download ${SOURCE_DISPLAY[source]} (${availableInSource})` }
                                    </button>
                                ) }
                            </div>
                            <Grid
                                columns={ columns }
                                defaultColumnSpacing={ 2 }
                                rows={ sourceRows }
                                downloadFile={ fileAvailabilityApi.downloadFile }
                                sortable
                            />
                        </div>
                    );
                }) }
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    const isSupport = Array.isArray(state.settings.userRole)
        && state.settings.userRole.some(r => r.role === 'ExecuteJobs');
    const filters = getFilters(state, 'FileAvailability');
    return {
        columns: selectors.combinedColumnsSelector(state)
            .filter(col => col.id !== 'download' || isSupport),
        rows: selectors.getRows(state),
        loading: selectors.getLoading(state),
        isSupport,
        lastUpdated: selectors.getLastUpdated(state),
        runDate: selectors.getDateFrom(filters)
    };
};

export default withRouter(connect(mapStateToProps)(FileAvailability));
